import { HubspotSubscription } from '_constants/destinations';
import { getGeoInfo } from '_services/country';
import { ContactSearch } from '_types/functions/hubspot/contactSearch';
import { getCookie } from '_utils/cookies';
import axios from 'axios';

const CHECK_EMAIL_URL = '/hubspot/contacts/search?email=';

const HUBSPOT_ACCESS_TOKEN = process.env.HUBSPOT_ACCESS_TOKEN;
const HUBSPOT_URL = 'https://hubspot-forms-200347980091.us-central1.run.app';

const legalConsentOptions = {
  legitimateInterest: {
    subscriptionTypeIds: Object.values(HubspotSubscription)
      .filter((value): value is number => typeof value === 'number'),
    legalBasis: 'LEAD',
    value: true,
    text: 'I agree to the processing of my personal data in accordance with the Privacy Policy.',
  },
};

export const sendToHubspot = async (postData: any) => {
  const hutk = getCookie('hubspotutk');
  let ipAddress: string | undefined;

  if (hutk) {
    try {
      const geoInfo = await getGeoInfo();
      ipAddress = geoInfo?.data?.ip;
    } catch (error) {
      console.warn('Failed to retrieve geo info:', error);
    }
  }

  const payload = {
    ...postData,
    legalConsentOptions,
    context: {
      ...(hutk ? { hutk } : {}),
      pageUri: typeof window !== 'undefined' ? window.location.href : '',
      pageName:
        typeof window !== 'undefined' && typeof document !== 'undefined'
          ? document.title
          : '',
      ...(hutk && ipAddress ? { ipAddress } : {}),
    },
  };

  const response = await axios.post(HUBSPOT_URL, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${HUBSPOT_ACCESS_TOKEN}`,
    },
  });
  return response;
};
export const hubspotEmailCheck = (email: string) =>
  axios.get<ContactSearch>(`${CHECK_EMAIL_URL}${email}`);
